import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, catchError, tap, throwError } from 'rxjs'
import { PerformanceMonitoringService } from '../core/services/performance-monitoring.service'
import { HTTP_RETRY_ATTEMPT, SKIP_PERFORMANCE_METRICS } from './performance.context'

@Injectable()
export class PerformanceInterceptor implements HttpInterceptor {
  constructor(private readonly monitoring: PerformanceMonitoringService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_PERFORMANCE_METRICS) || !this.isApiRequest(request.url)) {
      return next.handle(request)
    }

    const startedAt = performance.now()
    const attempt = request.context.get(HTTP_RETRY_ATTEMPT) + 1
    let recorded = false
    const record = (statusCode: number) => {
      if (recorded) return
      recorded = true
      this.monitoring.recordApiRequest({
        method: request.method,
        url: request.url,
        durationMs: performance.now() - startedAt,
        statusCode,
        attempt,
      })
    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) record(event.status)
      }),
      catchError((error: unknown) => {
        record(error instanceof HttpErrorResponse ? error.status : 0)
        return throwError(() => error)
      }),
    )
  }

  private isApiRequest(url: string): boolean {
    try {
      const parsedUrl = new URL(url, window.location.origin)
      return parsedUrl.origin === window.location.origin && parsedUrl.pathname.startsWith('/api/')
    } catch {
      return false
    }
  }
}
